import * as ActionTypes from 'actions/accountsAndLoans'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  accountsandloans: [],
  accountBalance: {},
  bankTransferAccounts: [],
  bankTransferAccountsOptions: [],
  lockedAccounts: [],
  selectedAccount: {},
}

const getBankTransferAccountsOptions = (bankTransferAccounts) => {
  const accountoptions = []
  // eslint-disable-next-line array-callback-return
  bankTransferAccounts.map((item) => {
    const label = `${item.accountNo} ${item.productType}(${item.partnerName}) Contract ${item.contract} ${
      // item.balance.toLocaleString(undefined, { maximumFractionDigits: 2 })
      item.balance.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' })
    } available`
    accountoptions.push({ value: `${item.accountNo}`, label: `${label}` })
  })
  return accountoptions
}

// Updates error message to notify about the failed fetches.
export default function accountsAndLoans(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.ACCOUNTSANDLOANS_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.ACCOUNTSANDLOANS_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        accountsandloans: action.accountsandloans,
      }
    case ActionTypes.ACCOUNTBALANCE_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        accountBalance: action.accountBalance,
      }
    case ActionTypes.ACCOUNTSANDLOANS_LOCK_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        lockedAccounts: action.lockedAccounts,
      }
    case ActionTypes.ACCOUNTSANDLOANS_BTA_RECEIVED: {
      const bankTransferAccounts = getBankTransferAccountsOptions(action.bankTransferAccounts)
      return {
        ...state,
        isFetching: false,
        fetched: true,
        bankTransferAccountsOptions: bankTransferAccounts,
        bankTransferAccounts: action.bankTransferAccounts,
      }
    }
    case ActionTypes.ACCOUNTSANDLOANS_SET_SELECTEDACCOUNT:
      return {
        ...state,
        selectedAccount: action.account,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accountsAndLoans.js